"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/notebook/v1/admin_service.proto (package spwn.notebook.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminNotebookServiceSetupPremierStreamingScheduleResponse = exports.AdminNotebookServiceSetupPremierStreamingScheduleRequest_Schedule = exports.AdminNotebookServiceSetupPremierStreamingScheduleRequest = exports.AdminNotebookServiceResetEndpointResponse = exports.AdminNotebookServiceResetEndpointRequest = exports.AdminNotebookServiceRegisterGoodsDataResponse = exports.AdminNotebookServiceRegisterGoodsDataRequest = exports.AdminNotebookServiceCreateGoodsDataForRegistrationResponse = exports.AdminNotebookServiceCreateGoodsDataForRegistrationRequest = exports.AdminNotebookServiceCreateStreamingSurveysResponse = exports.AdminNotebookServiceCreateStreamingSurveysRequest = exports.AdminNotebookServiceRegisterLogiResponse = exports.AdminNotebookServiceRegisterLogiRequest = exports.AdminNotebookServiceExecuteExportPurchasedOrdersJobResponse = exports.AdminNotebookServiceExecuteExportPurchasedOrdersJobRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const admin_common_pb_1 = require("./admin_common_pb");
/**
 * @generated from message spwn.notebook.v1.AdminNotebookServiceExecuteExportPurchasedOrdersJobRequest
 */
class AdminNotebookServiceExecuteExportPurchasedOrdersJobRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントID
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * 住所を含めるか
         *
         * @generated from field: bool has_address = 2;
         */
        this.hasAddress = false;
        /**
         * アンケートを含めるか
         *
         * @generated from field: bool has_questionnaire = 3;
         */
        this.hasQuestionnaire = false;
        /**
         * 抽出結果通知先メールアドレス
         *
         * @generated from field: string email = 4;
         */
        this.email = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminNotebookServiceExecuteExportPurchasedOrdersJobRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminNotebookServiceExecuteExportPurchasedOrdersJobRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminNotebookServiceExecuteExportPurchasedOrdersJobRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminNotebookServiceExecuteExportPurchasedOrdersJobRequest, a, b);
    }
}
exports.AdminNotebookServiceExecuteExportPurchasedOrdersJobRequest = AdminNotebookServiceExecuteExportPurchasedOrdersJobRequest;
AdminNotebookServiceExecuteExportPurchasedOrdersJobRequest.runtime = protobuf_1.proto3;
AdminNotebookServiceExecuteExportPurchasedOrdersJobRequest.typeName = "spwn.notebook.v1.AdminNotebookServiceExecuteExportPurchasedOrdersJobRequest";
AdminNotebookServiceExecuteExportPurchasedOrdersJobRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "has_address", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "has_questionnaire", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.notebook.v1.AdminNotebookServiceExecuteExportPurchasedOrdersJobResponse
 */
class AdminNotebookServiceExecuteExportPurchasedOrdersJobResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ジョブ実行結果
         *
         * @generated from field: bool is_successful = 1;
         */
        this.isSuccessful = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminNotebookServiceExecuteExportPurchasedOrdersJobResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminNotebookServiceExecuteExportPurchasedOrdersJobResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminNotebookServiceExecuteExportPurchasedOrdersJobResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminNotebookServiceExecuteExportPurchasedOrdersJobResponse, a, b);
    }
}
exports.AdminNotebookServiceExecuteExportPurchasedOrdersJobResponse = AdminNotebookServiceExecuteExportPurchasedOrdersJobResponse;
AdminNotebookServiceExecuteExportPurchasedOrdersJobResponse.runtime = protobuf_1.proto3;
AdminNotebookServiceExecuteExportPurchasedOrdersJobResponse.typeName = "spwn.notebook.v1.AdminNotebookServiceExecuteExportPurchasedOrdersJobResponse";
AdminNotebookServiceExecuteExportPurchasedOrdersJobResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "is_successful", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.notebook.v1.AdminNotebookServiceRegisterLogiRequest
 */
class AdminNotebookServiceRegisterLogiRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントIDs
         *
         * @generated from field: repeated string event_ids = 1;
         */
        this.eventIds = [];
        /**
         * エクセル入力データ
         *
         * @generated from field: repeated spwn.notebook.v1.LogiFileData logi_file_data = 2;
         */
        this.logiFileData = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminNotebookServiceRegisterLogiRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminNotebookServiceRegisterLogiRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminNotebookServiceRegisterLogiRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminNotebookServiceRegisterLogiRequest, a, b);
    }
}
exports.AdminNotebookServiceRegisterLogiRequest = AdminNotebookServiceRegisterLogiRequest;
AdminNotebookServiceRegisterLogiRequest.runtime = protobuf_1.proto3;
AdminNotebookServiceRegisterLogiRequest.typeName = "spwn.notebook.v1.AdminNotebookServiceRegisterLogiRequest";
AdminNotebookServiceRegisterLogiRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "logi_file_data", kind: "message", T: admin_common_pb_1.LogiFileData, repeated: true },
]);
/**
 * @generated from message spwn.notebook.v1.AdminNotebookServiceRegisterLogiResponse
 */
class AdminNotebookServiceRegisterLogiResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントIDs
         *
         * @generated from field: repeated string event_ids = 1;
         */
        this.eventIds = [];
        /**
         * 登録データ
         *
         * @generated from field: repeated spwn.notebook.v1.LogiItem logi_item_list = 2;
         */
        this.logiItemList = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminNotebookServiceRegisterLogiResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminNotebookServiceRegisterLogiResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminNotebookServiceRegisterLogiResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminNotebookServiceRegisterLogiResponse, a, b);
    }
}
exports.AdminNotebookServiceRegisterLogiResponse = AdminNotebookServiceRegisterLogiResponse;
AdminNotebookServiceRegisterLogiResponse.runtime = protobuf_1.proto3;
AdminNotebookServiceRegisterLogiResponse.typeName = "spwn.notebook.v1.AdminNotebookServiceRegisterLogiResponse";
AdminNotebookServiceRegisterLogiResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "logi_item_list", kind: "message", T: admin_common_pb_1.LogiItem, repeated: true },
]);
/**
 * @generated from message spwn.notebook.v1.AdminNotebookServiceCreateStreamingSurveysRequest
 */
class AdminNotebookServiceCreateStreamingSurveysRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: repeated spwn.notebook.v1.NotebookStreamingSurveys survey_list = 2;
         */
        this.surveyList = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminNotebookServiceCreateStreamingSurveysRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminNotebookServiceCreateStreamingSurveysRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminNotebookServiceCreateStreamingSurveysRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminNotebookServiceCreateStreamingSurveysRequest, a, b);
    }
}
exports.AdminNotebookServiceCreateStreamingSurveysRequest = AdminNotebookServiceCreateStreamingSurveysRequest;
AdminNotebookServiceCreateStreamingSurveysRequest.runtime = protobuf_1.proto3;
AdminNotebookServiceCreateStreamingSurveysRequest.typeName = "spwn.notebook.v1.AdminNotebookServiceCreateStreamingSurveysRequest";
AdminNotebookServiceCreateStreamingSurveysRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "survey_list", kind: "message", T: admin_common_pb_1.NotebookStreamingSurveys, repeated: true },
]);
/**
 * @generated from message spwn.notebook.v1.AdminNotebookServiceCreateStreamingSurveysResponse
 */
class AdminNotebookServiceCreateStreamingSurveysResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminNotebookServiceCreateStreamingSurveysResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminNotebookServiceCreateStreamingSurveysResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminNotebookServiceCreateStreamingSurveysResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminNotebookServiceCreateStreamingSurveysResponse, a, b);
    }
}
exports.AdminNotebookServiceCreateStreamingSurveysResponse = AdminNotebookServiceCreateStreamingSurveysResponse;
AdminNotebookServiceCreateStreamingSurveysResponse.runtime = protobuf_1.proto3;
AdminNotebookServiceCreateStreamingSurveysResponse.typeName = "spwn.notebook.v1.AdminNotebookServiceCreateStreamingSurveysResponse";
AdminNotebookServiceCreateStreamingSurveysResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * [グッズ登録] スプレッドシートのidから、グッズ情報を取得し、確認用に変更前と変更後のグッズデータを返す。
 *
 * @generated from message spwn.notebook.v1.AdminNotebookServiceCreateGoodsDataForRegistrationRequest
 */
class AdminNotebookServiceCreateGoodsDataForRegistrationRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string spread_sheet_id = 1;
         */
        this.spreadSheetId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminNotebookServiceCreateGoodsDataForRegistrationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminNotebookServiceCreateGoodsDataForRegistrationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminNotebookServiceCreateGoodsDataForRegistrationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminNotebookServiceCreateGoodsDataForRegistrationRequest, a, b);
    }
}
exports.AdminNotebookServiceCreateGoodsDataForRegistrationRequest = AdminNotebookServiceCreateGoodsDataForRegistrationRequest;
AdminNotebookServiceCreateGoodsDataForRegistrationRequest.runtime = protobuf_1.proto3;
AdminNotebookServiceCreateGoodsDataForRegistrationRequest.typeName = "spwn.notebook.v1.AdminNotebookServiceCreateGoodsDataForRegistrationRequest";
AdminNotebookServiceCreateGoodsDataForRegistrationRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "spread_sheet_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.notebook.v1.AdminNotebookServiceCreateGoodsDataForRegistrationResponse
 */
class AdminNotebookServiceCreateGoodsDataForRegistrationResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: int64 max_purchase_tickets = 3;
         */
        this.maxPurchaseTickets = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: repeated spwn.notebook.v1.GoodsData goods_data = 4;
         */
        this.goodsData = [];
        /**
         * @generated from field: repeated spwn.notebook.v1.GoodsData changed_goods_data = 5;
         */
        this.changedGoodsData = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminNotebookServiceCreateGoodsDataForRegistrationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminNotebookServiceCreateGoodsDataForRegistrationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminNotebookServiceCreateGoodsDataForRegistrationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminNotebookServiceCreateGoodsDataForRegistrationResponse, a, b);
    }
}
exports.AdminNotebookServiceCreateGoodsDataForRegistrationResponse = AdminNotebookServiceCreateGoodsDataForRegistrationResponse;
AdminNotebookServiceCreateGoodsDataForRegistrationResponse.runtime = protobuf_1.proto3;
AdminNotebookServiceCreateGoodsDataForRegistrationResponse.typeName = "spwn.notebook.v1.AdminNotebookServiceCreateGoodsDataForRegistrationResponse";
AdminNotebookServiceCreateGoodsDataForRegistrationResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "max_purchase_tickets", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "goods_data", kind: "message", T: admin_common_pb_1.GoodsData, repeated: true },
    { no: 5, name: "changed_goods_data", kind: "message", T: admin_common_pb_1.GoodsData, repeated: true },
]);
/**
 * [グッズ登録] 確定したグッズデータをFirestoreに保存する
 *
 * @generated from message spwn.notebook.v1.AdminNotebookServiceRegisterGoodsDataRequest
 */
class AdminNotebookServiceRegisterGoodsDataRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: string spreadsheet_id = 2;
         */
        this.spreadsheetId = "";
        /**
         * @generated from field: int64 max_purchase_tickets = 3;
         */
        this.maxPurchaseTickets = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: repeated spwn.notebook.v1.GoodsData goods_data = 4;
         */
        this.goodsData = [];
        /**
         * @generated from field: bool is_register_live_commerce = 5;
         */
        this.isRegisterLiveCommerce = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminNotebookServiceRegisterGoodsDataRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminNotebookServiceRegisterGoodsDataRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminNotebookServiceRegisterGoodsDataRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminNotebookServiceRegisterGoodsDataRequest, a, b);
    }
}
exports.AdminNotebookServiceRegisterGoodsDataRequest = AdminNotebookServiceRegisterGoodsDataRequest;
AdminNotebookServiceRegisterGoodsDataRequest.runtime = protobuf_1.proto3;
AdminNotebookServiceRegisterGoodsDataRequest.typeName = "spwn.notebook.v1.AdminNotebookServiceRegisterGoodsDataRequest";
AdminNotebookServiceRegisterGoodsDataRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "spreadsheet_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "max_purchase_tickets", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "goods_data", kind: "message", T: admin_common_pb_1.GoodsData, repeated: true },
    { no: 5, name: "is_register_live_commerce", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.notebook.v1.AdminNotebookServiceRegisterGoodsDataResponse
 */
class AdminNotebookServiceRegisterGoodsDataResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminNotebookServiceRegisterGoodsDataResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminNotebookServiceRegisterGoodsDataResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminNotebookServiceRegisterGoodsDataResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminNotebookServiceRegisterGoodsDataResponse, a, b);
    }
}
exports.AdminNotebookServiceRegisterGoodsDataResponse = AdminNotebookServiceRegisterGoodsDataResponse;
AdminNotebookServiceRegisterGoodsDataResponse.runtime = protobuf_1.proto3;
AdminNotebookServiceRegisterGoodsDataResponse.typeName = "spwn.notebook.v1.AdminNotebookServiceRegisterGoodsDataResponse";
AdminNotebookServiceRegisterGoodsDataResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.notebook.v1.AdminNotebookServiceResetEndpointRequest
 */
class AdminNotebookServiceResetEndpointRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントID
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * ビデオID
         *
         * @generated from field: string video_id = 2;
         */
        this.videoId = "";
        /**
         * 配信をするMediaLiveのチャンネルID
         *
         * @generated from field: string target_channel_id = 3;
         */
        this.targetChannelId = "";
        /**
         * エンドポイントの名称を本番用・リハ用で切り替えるフラグ
         *
         * @generated from field: bool is_prod = 4;
         */
        this.isProd = false;
        /**
         * エンドポイント再作成時の名称変更に使うカウントアップ用index
         *
         * @generated from field: int32 index = 5;
         */
        this.index = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminNotebookServiceResetEndpointRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminNotebookServiceResetEndpointRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminNotebookServiceResetEndpointRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminNotebookServiceResetEndpointRequest, a, b);
    }
}
exports.AdminNotebookServiceResetEndpointRequest = AdminNotebookServiceResetEndpointRequest;
AdminNotebookServiceResetEndpointRequest.runtime = protobuf_1.proto3;
AdminNotebookServiceResetEndpointRequest.typeName = "spwn.notebook.v1.AdminNotebookServiceResetEndpointRequest";
AdminNotebookServiceResetEndpointRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "video_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "target_channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_prod", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.notebook.v1.AdminNotebookServiceResetEndpointResponse
 */
class AdminNotebookServiceResetEndpointResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminNotebookServiceResetEndpointResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminNotebookServiceResetEndpointResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminNotebookServiceResetEndpointResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminNotebookServiceResetEndpointResponse, a, b);
    }
}
exports.AdminNotebookServiceResetEndpointResponse = AdminNotebookServiceResetEndpointResponse;
AdminNotebookServiceResetEndpointResponse.runtime = protobuf_1.proto3;
AdminNotebookServiceResetEndpointResponse.typeName = "spwn.notebook.v1.AdminNotebookServiceResetEndpointResponse";
AdminNotebookServiceResetEndpointResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.notebook.v1.AdminNotebookServiceSetupPremierStreamingScheduleRequest
 */
class AdminNotebookServiceSetupPremierStreamingScheduleRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントID
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * 配信をするMediaLiveのチャンネルID
         *
         * @generated from field: string target_channel_id = 2;
         */
        this.targetChannelId = "";
        /**
         * スケジュール設定したい時間
         *
         * @generated from field: repeated spwn.notebook.v1.AdminNotebookServiceSetupPremierStreamingScheduleRequest.Schedule schedules = 4;
         */
        this.schedules = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminNotebookServiceSetupPremierStreamingScheduleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminNotebookServiceSetupPremierStreamingScheduleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminNotebookServiceSetupPremierStreamingScheduleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminNotebookServiceSetupPremierStreamingScheduleRequest, a, b);
    }
}
exports.AdminNotebookServiceSetupPremierStreamingScheduleRequest = AdminNotebookServiceSetupPremierStreamingScheduleRequest;
AdminNotebookServiceSetupPremierStreamingScheduleRequest.runtime = protobuf_1.proto3;
AdminNotebookServiceSetupPremierStreamingScheduleRequest.typeName = "spwn.notebook.v1.AdminNotebookServiceSetupPremierStreamingScheduleRequest";
AdminNotebookServiceSetupPremierStreamingScheduleRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "latency", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "schedules", kind: "message", T: AdminNotebookServiceSetupPremierStreamingScheduleRequest_Schedule, repeated: true },
]);
/**
 * @generated from message spwn.notebook.v1.AdminNotebookServiceSetupPremierStreamingScheduleRequest.Schedule
 */
class AdminNotebookServiceSetupPremierStreamingScheduleRequest_Schedule extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 蓋絵の開始時刻
         *
         * @generated from field: int32 start_cover_begin_time = 1;
         */
        this.startCoverBeginTime = 0;
        /**
         * 本編の開始時刻
         *
         * @generated from field: int32 begin_time = 2;
         */
        this.beginTime = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminNotebookServiceSetupPremierStreamingScheduleRequest_Schedule().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminNotebookServiceSetupPremierStreamingScheduleRequest_Schedule().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminNotebookServiceSetupPremierStreamingScheduleRequest_Schedule().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminNotebookServiceSetupPremierStreamingScheduleRequest_Schedule, a, b);
    }
}
exports.AdminNotebookServiceSetupPremierStreamingScheduleRequest_Schedule = AdminNotebookServiceSetupPremierStreamingScheduleRequest_Schedule;
AdminNotebookServiceSetupPremierStreamingScheduleRequest_Schedule.runtime = protobuf_1.proto3;
AdminNotebookServiceSetupPremierStreamingScheduleRequest_Schedule.typeName = "spwn.notebook.v1.AdminNotebookServiceSetupPremierStreamingScheduleRequest.Schedule";
AdminNotebookServiceSetupPremierStreamingScheduleRequest_Schedule.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "start_cover_begin_time", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "begin_time", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.notebook.v1.AdminNotebookServiceSetupPremierStreamingScheduleResponse
 */
class AdminNotebookServiceSetupPremierStreamingScheduleResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminNotebookServiceSetupPremierStreamingScheduleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminNotebookServiceSetupPremierStreamingScheduleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminNotebookServiceSetupPremierStreamingScheduleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminNotebookServiceSetupPremierStreamingScheduleResponse, a, b);
    }
}
exports.AdminNotebookServiceSetupPremierStreamingScheduleResponse = AdminNotebookServiceSetupPremierStreamingScheduleResponse;
AdminNotebookServiceSetupPremierStreamingScheduleResponse.runtime = protobuf_1.proto3;
AdminNotebookServiceSetupPremierStreamingScheduleResponse.typeName = "spwn.notebook.v1.AdminNotebookServiceSetupPremierStreamingScheduleResponse";
AdminNotebookServiceSetupPremierStreamingScheduleResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
//# sourceMappingURL=admin_service_pb.js.map